export const MapState = ({ executionsReducer }) => {
  return {
    isFetchingExecution: executionsReducer.isFetchingExecution,
    executionIsRunning: executionsReducer.executionIsRunning,
    executionMessage: executionsReducer.message,
  };
};

export const MapDispatch = dispatch => ({});
